import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalMasterDetailView from "../../../components/modal/ModalMasterDetailView";
import { timelineViewSettingsOperations } from "../../../modules/definition/timelineViewSettings";
import { typeOperations } from "../../../modules/definition/types";
import { PropTypeShapes } from "../../../types";
import SettingsTypeDetailView from "./SettingsTypeDetailView";

const listItems = props => {
  return props.types.allIds
    .map(tId => {
      const t = props.types.byId.get(tId);

      let showWarning = false;
      props.types.allIds.map(stId => {
        const st = props.types.byId.get(stId);
        const isChecked = t.superTypes.indexOf(stId) >= 0;
        const parentTypeNotAllowed = t.showInSequence && isChecked && !st.showInSequence;
        if (parentTypeNotAllowed) {
          showWarning = true;
        }
      });

      return {
        label: t.label,
        value: t.id,
        color: t.color,
        icon: t.icon,
        canDelete: t.canDelete,
        className: showWarning ? "warning" : null
      };
    })
    .toArray();
};

class SettingsTypesTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <ModalMasterDetailView
        items={listItems(this.props)}
        onItemSelect={this.selectItem}
        onAddClick={this.props.onAddType}
        onDeleteClick={this.props.onRemoveType}
        allowDrag={true}
        onMoveItemAtIndex={this.props.onMoveType}
        backText="Types"
        itemsUseIndexAsId={false}
        //#!if iOS === true
// onDoneClick={this.props.onDoneClick}
// doneDisabled={this.props.doneDisabled}
// footer={this.props.footer}
        //#!endif
      >
        <SettingsTypeDetailView {...this.props} />
      </ModalMasterDetailView>
    );
  }
}

SettingsTypesTab.propTypes = {
  types: PropTypeShapes.denormalisedTypeDefinitionsIdList.isRequired,
  references: PropTypeShapes.denormalisedReferenceDefinitionsIdList.isRequired,
  properties: PropTypeShapes.propertyDefinitionsIdList.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onPluralLabelChange: PropTypes.func.isRequired,
  onLabelDisplayLabelChange: PropTypes.func.isRequired,
  onStartDisplayLabelChange: PropTypes.func.isRequired,
  onEndDisplayLabelChange: PropTypes.func.isRequired,
  onAnniversaryDisplayLabelChange: PropTypes.func.isRequired,
  onExtendAnniversaryBeyondEndChange: PropTypes.func.isRequired,
  onIconChange: PropTypes.func.isRequired,
  onCanHaveDateChange: PropTypes.func.isRequired,
  onShowInSequenceChange: PropTypes.func.isRequired,
  onIncludeInNarrativeChange: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onEnabledChange: PropTypes.func.isRequired,
  onShowOnSidebarChange: PropTypes.func.isRequired,
  onShowAsColumnChange: PropTypes.func.isRequired,
  onPrefixChange: PropTypes.func.isRequired,
  onCompactDisplayChange: PropTypes.func.isRequired,
  onHasPropertyChange: PropTypes.func.isRequired,
  onHasReferenceChange: PropTypes.func.isRequired,
  onHasSuperTypeChange: PropTypes.func.isRequired,
  onAddType: PropTypes.func.isRequired,
  onMoveType: PropTypes.func.isRequired,
  onRemoveType: PropTypes.func.isRequired,
  onCanHaveLocationUriChange: PropTypes.func.isRequired,
  colorOptions: PropTypeShapes.listOptionList.isRequired,
  timelineViewSettings: PropTypeShapes.timelineViewSettings.isRequired,
  onShowTypeChange: PropTypes.func.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired,
// doneDisabled: PropTypes.bool,
// footer: PropTypes.element
  //#!endif
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onIconChange: (typeId, icon) => {
      props.dispatchLocal(typeOperations.changeIcon(typeId, icon.icon, icon.color));
    },
    onLabelChange: (typeId, label) => {
      props.dispatchLocal(typeOperations.changeLabel(typeId, label));
    },
    onDefaultItemColorChange: (typeId, color) => {
      props.dispatchLocal(typeOperations.changeDefaultItemColor(typeId, color));
    },
    onPluralLabelChange: (typeId, pluralLabel) => {
      props.dispatchLocal(typeOperations.changePlural(typeId, pluralLabel));
    },
    onLabelDisplayLabelChange: (typeId, label) => {
      props.dispatchLocal(typeOperations.changeLabelDisplayLabel(typeId, label));
    },
    onStartDisplayLabelChange: (typeId, label) => {
      props.dispatchLocal(typeOperations.changeStartDisplayLabel(typeId, label));
    },
    onEndDisplayLabelChange: (typeId, label) => {
      props.dispatchLocal(typeOperations.changeEndDisplayLabel(typeId, label));
    },
    onAnniversaryDisplayLabelChange: (typeId, label) => {
      props.dispatchLocal(typeOperations.changeAnniversaryDisplayLabel(typeId, label));
    },
    onExtendAnniversaryBeyondEndChange: (typeId, val) => {
      props.dispatchLocal(typeOperations.changeExtendAnniversaryBeyondEnd(typeId, val));
    },
    onCanHaveDateChange: (typeId, canHaveDate) => {
      props.dispatchLocal(typeOperations.changeCanHaveDate(typeId, canHaveDate));
    },
    onShowInSequenceChange: (typeId, includeInSequence) => {
      props.dispatchLocal(typeOperations.changeShowInSequence(typeId, includeInSequence));
    },
    onIncludeInNarrativeChange: (typeId, includeInNarrative) => {
      props.dispatchLocal(typeOperations.changeIncludeInNarrative(typeId, includeInNarrative));
    },
    onShowOnSidebarChange: (typeId, showOnSidebar) => {
      props.dispatchLocal(typeOperations.changeShowOnSidebar(typeId, showOnSidebar));
    },
    onShowAsColumnChange: (typeId, showAsColumn) => {
      props.dispatchLocal(typeOperations.changeShowAsColumn(typeId, showAsColumn));
    },
    onPrefixChange: (typeId, prefix) => {
      props.dispatchLocal(typeOperations.changePrefix(typeId, prefix));
    },
    onCompactDisplayChange: (typeId, newValue) => {
      props.dispatchLocal(typeOperations.changeCompactDisplay(typeId, newValue));
    },
    onHasPropertyChange: (typeId, propertyId, isIncluded) => {
      props.dispatchLocal(typeOperations.changeHasProperty(typeId, propertyId, isIncluded));
    },
    onHasReferenceChange: (typeId, referenceId, isIncluded) => {
      props.dispatchLocal(typeOperations.changeHasReference(typeId, referenceId, isIncluded));
    },
    onHasSuperTypeChange: (typeId, superTypeId, isIncluded) => {
      props.dispatchLocal(typeOperations.changeHasSuperType(typeId, superTypeId, isIncluded));
    },
    onCategoryChange: (typeId, category) => {
      props.dispatchLocal(typeOperations.changeCategory(typeId, category));
    },
    onEnabledChange: (typeId, enabled) => {
      props.dispatchLocal(typeOperations.changeEnabled(typeId, enabled));
    },
    onAddType: () => {
      props.dispatchLocal(typeOperations.createType());
    },
    onMoveType: (fromIndex, toIndex) => {
      props.dispatchLocal(typeOperations.moveType(fromIndex, toIndex));
    },
    onRemoveType: typeId => {
      props.dispatchLocal(typeOperations.deleteType(typeId));
    },
    onCanHaveLocationUriChange: (typeId, canHaveLocationUri) => {
      props.dispatchLocal(typeOperations.changeCanHaveLocationUri(typeId, canHaveLocationUri));
    },
    onShowTypeChange: (typeId, show) => {
      props.dispatchLocal(timelineViewSettingsOperations.changeShowType(typeId, show));
    }
  };
};

export default connect(null, mapDispatchToProps)(SettingsTypesTab);
